import axios from 'axios';

const BASE_URL = 'https://api.mark.msdiscoveries.com/api';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 120000, // 2 minutes — needed for large CSV imports (1000+ rows)
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();
      const path = window.location.pathname;
      if (path.startsWith('/admin')) window.location.href = '/admin';
      else if (path.startsWith('/client')) window.location.href = '/client';
    }
    return Promise.reject(err);
  }
);

export default api;